import React, { useEffect, useState } from "react";
import secureLocalStorage from "react-secure-storage";
import CardDiv from "modules/common/card-div/CardDiv";
import MyWorkFilter from "./MyWorkFilter";
import MyWorkTable from "./MyWorkTable";
import { useEngagementStore } from "./store";

function MyWork() {
  const { fetchQAFilters, filtersError } = useEngagementStore();
  const qaName = secureLocalStorage.getItem("first_name");

  useEffect(() => {
    fetchQAFilters();
  }, []);

  return (
    <CardDiv
      title={
        <div className="d-flex my-n2 justify-content-between align-items-center">
          <div>
            Hello 👋 <span className="ms-2">{qaName.toUpperCase()}</span>
          </div>
          <MyWorkFilter disableButton={filtersError !== null} />
        </div>
      }
      component={<MyWorkTable />}
    />
  );
}

export default MyWork;
